import * as actions from "../action.constants";
const requestContacts = (pageUrl) => ({
  type: actions.REQUEST_GET_CONTACTS_LIST_SAGA,
  pageUrl,
});

const saveContactsList = (data) => ({
  type: actions.SAVE_GET_CONTACTS_LIST,
  payload: data,
});

const updateAddContactModal = (data) => ({
  type: actions.SAVE_ADD_CONTACT_MODAL_STATUS,
  payload: data,
});

const sendContactModalData = (data, callback) => ({
  type: actions.REQUEST_SEND_CONTACT_DATA_SAGA,
  payload: data,
  callback,
});

const sendDeleteContactRequest = (data, callback) => ({
  type: actions.REQUEST_DELETE_CONTACT_SAGA,
  payload: data,
  callback,
});

export {
  sendContactModalData,
  requestContacts,
  updateAddContactModal,
  saveContactsList,
  sendDeleteContactRequest,
};
